import { CrudList } from '../shared/CrudPage';
import { brandService } from '@kss/api';
import type { Brand, BrandCreate, BrandFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';
import { AuthImg } from '../../components/AuthImg';

export default function AllBrands() {
  return (
    <CrudList<Brand, BrandCreate, BrandFilter>
      title="Brands"
      newLabel="New brand"
      service={brandService}
      idKey="brandId"
      labelKey="name"
      basePath="/panel/brands"
      columns={[
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'description', title: 'Description', render: (r) => r.description || '—' },
        {
          accessor: 'logoUrl',
          title: 'Logo',
          width: 80,
          render: (r) =>
            r.logoUrl ? <AuthImg src={String(r.logoUrl)} className="h-8 w-8 rounded object-cover" /> : '—',
        },
        {
          accessor: 'isActive',
          title: 'Status',
          width: 110,
          render: (r) => <StatusBadge status={r.isActive ? 'active' : 'inactive'} />,
        },
      ]}
    />
  );
}
